import { Routes } from '@angular/router';
import { PermissionsGuard } from '../../core/guards/permissions.guard';

export const homeRoutes: Routes = [
    {
      path: '',
      redirectTo: 'dashboard',
      pathMatch: 'full',
    },
    {
      path: 'dashboard',
      loadComponent: () =>
      import('./dashboard/dashboard.component').then(
        (m) => m.DashboardComponent
      ),
    },
    {
      path: 'settings',
      loadComponent: () => 
      import('./settings/settings.component').then(
        (m) => m.SettingsComponent
      ),
    },
    {
      path: 'profile',
      loadComponent: () => 
      import('./profile/profile.component').then(
        (m) => m.ProfileComponent
      ),
    },
    {
      path: 'users',
      loadComponent: () => 
      import('./users/users.component').then(
        (m) => m.UsersComponent
      ),
      // canActivate: [PermissionsGuard],
      // data: { 
      //   permissions: ['user.read'],
      //   requireAllPermissions: true
      // }
    },
    {
      path: 'users/:id',
      loadComponent: () =>
      import('./users/user-detail/user-detail.component').then(
        (m) => m.UserDetailComponent
      ),
      // canActivate: [PermissionsGuard],
      // data: { 
      //   permissions: ['user.read'],
      //   requireAllPermissions: true
      // }
    },
    {
      path: 'roles',
      loadComponent: () => 
      import('./roles/roles.component').then(
        (m) => m.RolesComponent
      ),
      // canActivate: [PermissionsGuard],
      // data: { 
      //   permissions: ['role.read'],
      //   requireAllPermissions: true
      // }
    },
    {
      path: 'document-detail/:id',
      loadComponent: () =>
      import('./document-detail/document-detail.component').then(
        (m) => m.DocumentDetailComponent
      ),
    },
    {
      path: 'payment-detail/:documentId',
      loadComponent: () =>
      import('./payment-detail/payment-detail.component').then(
        (m) => m.PaymentDetailComponent
      ),
    },
    {
      path: 'advanced-dashboard',
      loadComponent: () =>
      import('./advanced-dashboard/advanced-dashboard.component').then(
        (m) => m.AdvancedDashboardComponent
      ),
    },
    {
      path: 'admin/bank-accounts',
      loadComponent: () =>
      import('./admin/bank-accounts/bank-accounts.component').then(
        (m) => m.BankAccountsComponent
      ),
    },
    {
      path: 'admin/dispersion-rules',
      loadComponent: () =>
      import('./admin/dispersion-rules/dispersion-rules.component').then(
        (m) => m.DispersionRulesComponent
      ),
    },
    {
      path: 'admin/audit-logs',
      loadComponent: () =>
      import('./admin/audit-logs/audit-logs.component').then(
        (m) => m.AuditLogsComponent
      ),
    },
    {
      path: 'user/reset-password',
      loadComponent: () =>
      import('./user/reset-password/reset-password.component').then(
        (m) => m.ResetPasswordComponent
      ),
    }
  ];